import ProgressIcon from "web/assets/icons/progress.svg";

import classes from "./progress.scss";

const Progress = () => {
  return (
    <div className={classes.wrapper}>
      <ProgressIcon className={classes.spinner} />
    </div>
  );
};

export default Progress;
